import { toast } from 'react-toastify';
import './StyledToast.css';

export const OpenToast = (message, type, options = {}) => {
    if (type === 'error') {
        toast.error(message, { position: 'top-right', ...options });
    } else {
        toast(message, { position: 'top-right', ...options });
    }
};
